/* Narobic3D — interacciones (vanilla, sin librerías) */
(function () {
  'use strict';

  /* Animaciones de entrada al hacer scroll */
  function initReveals() {
    var elementos = document.querySelectorAll('.nrb-reveal');
    if (!elementos.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      elementos.forEach(function (el) { el.classList.add('nrb-visible'); });
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('nrb-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );
    elementos.forEach(function (el) { observer.observe(el); });
  }

  /* Galería de la página de producto: miniaturas -> imagen principal */
  function initGaleriaProducto() {
    var galerias = document.querySelectorAll('[data-nrb-galeria]');
    galerias.forEach(function (galeria) {
      var principal = galeria.querySelector('[data-nrb-principal] img');
      var minis = galeria.querySelectorAll('[data-nrb-mini]');
      if (!principal || !minis.length) return;
      minis.forEach(function (mini) {
        mini.addEventListener('click', function () {
          var img = mini.querySelector('img');
          if (!img) return;
          principal.src = img.dataset.grande || img.src;
          principal.alt = img.alt || '';
          minis.forEach(function (m) { m.classList.remove('nrb-activa'); });
          mini.classList.add('nrb-activa');
        });
      });
    });
  }

  /* Variantes de producto: actualizar id, precio y disponibilidad */
  function initVariantes() {
    var formularios = document.querySelectorAll('[data-nrb-producto-form]');
    formularios.forEach(function (contenedor) {
      var datos = contenedor.querySelector('script[type="application/json"]');
      if (!datos) return;
      var variantes;
      try { variantes = JSON.parse(datos.textContent); } catch (e) { return; }
      var selects = contenedor.querySelectorAll('[data-nrb-opcion]');
      var inputId = contenedor.querySelector('input[name="id"]');
      var boton = contenedor.querySelector('[data-nrb-boton]');
      var precioEl = contenedor.querySelector('[data-nrb-precio]');
      var precioAntesEl = contenedor.querySelector('[data-nrb-precio-antes]');
      var descuentoEl = contenedor.querySelector('[data-nrb-descuento]');
      if (!selects.length || !inputId) return;

      /* Si la variante tiene su propia foto, la galería la enseña: en el
         karambit cada color tiene la suya, y sin esto elegías "Verde" y
         seguías viendo el rojo. */
      var galeria = document.querySelector('[data-nrb-galeria]');
      var fotoPrincipal = galeria && galeria.querySelector('[data-nrb-principal] img');
      var minis = galeria ? galeria.querySelectorAll('[data-nrb-mini]') : [];

      function mostrarFoto(url, alt) {
        if (!fotoPrincipal || !url || fotoPrincipal.src === url) return;
        fotoPrincipal.src = url;
        if (alt) fotoPrincipal.alt = alt;
        minis.forEach(function (m) {
          var img = m.querySelector('img');
          var suya = img && (img.dataset.grande || img.src) === url;
          m.classList.toggle('nrb-activa', !!suya);
        });
      }

      function actualizar() {
        var elegido = [];
        selects.forEach(function (s) { elegido.push(s.value); });
        var variante = variantes.find(function (v) {
          return v.opciones.every(function (opt, i) { return opt === elegido[i]; });
        });
        if (!variante) {
          if (boton) {
            boton.disabled = true;
            boton.textContent = boton.dataset.textoAgotado || 'No disponible';
          }
          return;
        }
        inputId.value = variante.id;
        mostrarFoto(variante.foto, variante.foto_alt);
        if (precioEl) precioEl.textContent = variante.precio;
        if (precioAntesEl) {
          if (variante.precio_antes) {
            precioAntesEl.textContent = variante.precio_antes;
            precioAntesEl.hidden = false;
          } else {
            precioAntesEl.hidden = true;
          }
        }
        if (descuentoEl) {
          if (variante.descuento) {
            descuentoEl.textContent = '-' + variante.descuento + '%';
            descuentoEl.hidden = false;
          } else {
            descuentoEl.hidden = true;
          }
        }
        if (boton) {
          boton.disabled = !variante.disponible;
          boton.textContent = variante.disponible
            ? (boton.dataset.textoComprar || 'Añadir al carrito')
            : (boton.dataset.textoAgotado || 'Agotado');
        }
      }

      selects.forEach(function (s) { s.addEventListener('change', actualizar); });
    });
  }


  /* Boton flotante de "volver arriba": aparece al bajar una pantalla */
  function initVolverArriba() {
    var boton = document.querySelector('[data-nrb-arriba]');
    if (!boton) return;

    function alScroll() {
      if (window.scrollY > window.innerHeight * 0.9) {
        boton.hidden = false;
      } else {
        boton.hidden = true;
      }
    }

    window.addEventListener('scroll', alScroll, { passive: true });
    alScroll();

    boton.addEventListener('click', function () {
      var suave = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: suave ? 'smooth' : 'auto' });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveals();
    initGaleriaProducto();
    initVariantes();
    initVolverArriba();
  });
})();

/* Cuenta atrás de la oferta.
   Al llegar a cero se oculta y se queda quieto: no se reinicia nunca, porque
   una cuenta atrás que vuelve a empezar es publicidad engañosa. */
function initContador() {
  var bloques = document.querySelectorAll('[data-nrb-contador]');
  if (!bloques.length) return;

  Array.prototype.forEach.call(bloques, function (bloque) {
    var fin = new Date(String(bloque.dataset.fin).trim().replace(' ', 'T')).getTime();
    if (isNaN(fin)) return;

    var huecos = {
      dias: bloque.querySelector('[data-nrb-dias]'),
      horas: bloque.querySelector('[data-nrb-horas]'),
      minutos: bloque.querySelector('[data-nrb-minutos]'),
      segundos: bloque.querySelector('[data-nrb-segundos]')
    };
    var temporizador;

    function dos(n) { return n < 10 ? '0' + n : String(n); }

    function pintar() {
      var resta = fin - Date.now();
      if (resta <= 0) {
        bloque.hidden = true;
        clearInterval(temporizador);
        return;
      }
      var seg = Math.floor(resta / 1000);
      huecos.dias.textContent = dos(Math.floor(seg / 86400));
      huecos.horas.textContent = dos(Math.floor(seg % 86400 / 3600));
      huecos.minutos.textContent = dos(Math.floor(seg % 3600 / 60));
      huecos.segundos.textContent = dos(seg % 60);
      bloque.hidden = false;
    }

    pintar();
    temporizador = setInterval(pintar, 1000);
  });
}

/* Botón de compra fijo en el móvil.
   No duplica el formulario: envía el de arriba, así siguen valiendo los campos
   obligatorios y el archivo del logo. */
function initCompraFija() {
  var barra = document.querySelector('[data-nrb-compra-fija]');
  var boton = document.querySelector('[data-nrb-compra-fija-btn]');
  var formulario = document.querySelector('.nrb-producto__form');
  var original = document.querySelector('[data-nrb-boton]');
  if (!barra || !boton || !formulario || !original) return;

  if ('IntersectionObserver' in window) {
    var vigia = new IntersectionObserver(function (entradas) {
      // la barra solo molesta mientras se ve el botón de verdad
      barra.hidden = entradas[0].isIntersecting;
      marcar();
    }, { rootMargin: '0px 0px -40px 0px' });
    vigia.observe(original);
  } else {
    barra.hidden = false;
    marcar();
  }

  // avisa al CSS para que el botón de volver arriba no se solape con la barra
  function marcar() {
    document.documentElement.classList.toggle('nrb-con-barra', !barra.hidden);
  }

  boton.addEventListener('click', function () {
    if (!formulario.checkValidity()) {
      // falta algo por rellenar: lo llevamos al campo en vez de fallar en silencio
      barra.hidden = true;
      original.scrollIntoView({ block: 'center', behavior: 'smooth' });
      setTimeout(function () { formulario.reportValidity(); }, 400);
      return;
    }
    formulario.submit();
  });
}

/* Este archivo lo incluye cada sección nrb-, así que en una ficha de producto
   se ejecuta varias veces. La marca evita montar dos relojes sobre el mismo
   elemento y duplicar los temporizadores. */
(function arrancarNrbVenta() {
  function arrancar() {
    if (document.documentElement.dataset.nrbVentaLista === '1') return;
    document.documentElement.dataset.nrbVentaLista = '1';
    initContador();
    initCompraFija();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
})();
